import { CoursePricingOption } from '../../../../../../store/features/coursePricing';

export function getSlicedRows(
  rows: CoursePricingOption[],
  showMoreAfter?: number,
) {
  return showMoreAfter ? rows.slice(0, showMoreAfter) : rows;
}
